import ReportLayout from './ReportLayout';

export default ReportLayout;
